export default __webpack_public_path__ + "static/media/cleanproVoucher2.1a9c6f13.png";